/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type PendingMemberCardActionsDialogMutationVariables = {
    inviteId: string;
};
export type PendingMemberCardActionsDialogMutationResponse = {
    readonly revokeMemberInvite: {
        readonly success: boolean;
    };
};
export type PendingMemberCardActionsDialogMutation = {
    readonly response: PendingMemberCardActionsDialogMutationResponse;
    readonly variables: PendingMemberCardActionsDialogMutationVariables;
};



/*
mutation PendingMemberCardActionsDialogMutation(
  $inviteId: ID!
) {
  revokeMemberInvite(input: {inviteId: $inviteId}) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "inviteId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "inviteId",
            "variableName": "inviteId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RevokeMemberInvitePayload",
    "kind": "LinkedField",
    "name": "revokeMemberInvite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PendingMemberCardActionsDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PendingMemberCardActionsDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7d6618c8bddb700423688fd742788893",
    "id": null,
    "metadata": {},
    "name": "PendingMemberCardActionsDialogMutation",
    "operationKind": "mutation",
    "text": "mutation PendingMemberCardActionsDialogMutation(\n  $inviteId: ID!\n) {\n  revokeMemberInvite(input: {inviteId: $inviteId}) {\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = '86091dfbb546fbcbc8d74703acceadc5';
export default node;
